"use client";

import ServicesBanner from "@/app/[locale]/services/_components/services-banner";
import ServicesExperience from "@/app/[locale]/services/_components/services-experience";
import ServicesPlanning from "@/app/[locale]/services/_components/services-planning";
import ServicesStrategy from "@/app/[locale]/services/_components/services-strategy";

const ServicesPage = () => {

	return (
		<>
			<ServicesBanner />

			<ServicesStrategy />

			<ServicesExperience />

			<ServicesPlanning />
		</>
	)
};

export default ServicesPage;
